import { Injectable } from '@angular/core';
import { AccessControlListService, UserGroupAcl, UserGroupAclGroups, UserGroupAclMembers } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import {
  SettingPermissionsResolverActions,
  AccessControlListApiActions,
  UserAclPermissionsUiActions,
  GroupAclPermissionsUiActions,
} from './user-group-acl.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class UserGroupAclEffects {
  constructor(
    private readonly accessControlListService: AccessControlListService,
    private readonly actions$: Actions
  ) {}

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SettingPermissionsResolverActions.userGroupAclRequested),
      mergeMap(({ resourceId }) =>
        safeMap(
          this.accessControlListService.getUserGroupAcl(resourceId),
          (userGroupAcl: UserGroupAcl) => AccessControlListApiActions.userGroupAclLoaded({ userGroupAcl }),
          (error) => AccessControlListApiActions.userGroupAclLoadedError({ error })
        )
      )
    );
  });

  userGroupAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserAclPermissionsUiActions.userGroupAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.accessControlListService
          .putUserGroupAclMembers(aclMember)
          .pipe(
            map((userGroupAclMember: UserGroupAclMembers) =>
              AccessControlListApiActions.userGroupAclMemberPut({ aclMember: userGroupAclMember })
            )
          )
      )
    );
  });

  userGroupAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupAclPermissionsUiActions.userGroupAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.accessControlListService
          .putUserGroupAclGroups(aclGroup)
          .pipe(
            map((userGroupAclGroup: UserGroupAclGroups) =>
              AccessControlListApiActions.userGroupAclGroupPut({ aclGroup: userGroupAclGroup })
            )
          )
      )
    );
  });
}
